import React from 'react';
import AccessCard from 'components/AccessCard';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import SectionBasePage from 'components/SectionBasePage';
import { Icons } from 'UI';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';

import {
  MainContainer,
} from './style';

const RootPage = (): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const { url } = useRouteMatch();

  const resourcesAction = () => breadcrumbNavigator.push({
    label: 'Cadastro',
    url: `${url}${ROUTES.dashboard.inventory.resource.root}`,
  });

  const ticketsAction = () => breadcrumbNavigator.push({
    label: 'Pedidos de compra',
    url: `${url}${ROUTES.dashboard.inventory.tickets.root}`,
  });

  const organizationInventoryAction = () => breadcrumbNavigator.push({
    label: 'Viveiro',
    url: `${url}${ROUTES.dashboard.inventory.organization.root}`,
  });

  const clientInventoryAction = () => breadcrumbNavigator.push({
    label: 'Clientes',
    url: `${url}${ROUTES.dashboard.inventory.client.root}`,
  });

  return (
    <SectionBasePage title="Estoque">
      <MainContainer>
        <AccessCard title="Cadastro" icon={<Icons.Seed />} action={resourcesAction} />
        <AccessCard title="Pedidos de compra" icon={<Icons.Order />} action={ticketsAction} />
        <AccessCard title="Viveiro" icon={<Icons.House />} action={organizationInventoryAction} />
        <AccessCard title="Clientes" icon={<Icons.User />} action={clientInventoryAction} />
      </MainContainer>
    </SectionBasePage>
  );
};

export default RootPage;
